import { forwardRef } from 'react';
import type React from 'react';

type OwnProps = React.SVGProps<SVGSVGElement>;

const CarIcon = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="97"
    height="50"
    viewBox="0 0 97 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.9035 45.9227C21.0675 45.9227 17.9475 42.8028 17.9475 38.9668C17.9475 35.1323 21.0675 32.0108 24.9035 32.0108C28.7395 32.0108 31.8595 35.1323 31.8595 38.9668C31.8595 42.8028 28.7395 45.9227 24.9035 45.9227ZM47.4454 37.4068H34.8454C34.0934 32.5911 29.9283 28.8908 24.9035 28.8908C19.8788 28.8908 15.7136 32.5911 14.9617 37.4068H3.11986V27.0516C3.11986 22.1033 7.22107 21.8428 8.04942 21.8412H16.4531C16.7994 21.8412 17.1348 21.7273 17.4062 21.5167L33.6317 8.97597L30.8533 7.18042L15.9211 18.7212H8.06502C7.9527 18.7275 4.59717 18.7181 2.24626 21.0472C0.756473 22.5229 -0.00012207 24.5431 -0.00012207 27.0516V38.9668C-0.00012207 39.8279 0.697193 40.5268 1.55987 40.5268H14.9617C15.7136 45.3424 19.8788 49.0427 24.9035 49.0427C29.9283 49.0427 34.0934 45.3424 34.8454 40.5268H47.4454V44.4127L56.874 38.9668L47.4454 33.5224V37.4068Z"
      fill="#00619E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.0947 45.9228C68.2586 45.9228 65.1387 42.8028 65.1387 38.9668C65.1387 35.1324 68.2586 32.0108 72.0947 32.0108C75.9307 32.0108 79.0507 35.1324 79.0507 38.9668C79.0507 42.8028 75.9307 45.9228 72.0947 45.9228ZM96.5412 27.5961C96.3524 27.2373 91.8378 18.9335 78.7792 18.6636L64.4569 4.34136C64.1652 4.04964 63.7689 3.88428 63.354 3.88428H43.5655V-9.15527e-05L34.1354 5.44427L43.5655 10.8902V7.00426H62.7081L77.0226 21.3203C77.3159 21.6136 77.7121 21.7774 78.1255 21.7774C88.4979 21.7774 92.7145 27.3637 93.599 28.749V37.4069H82.038C81.2845 32.5912 77.1193 28.8909 72.0946 28.8909C66.5379 28.8909 62.0186 33.4102 62.0186 38.9669C62.0186 44.5236 66.5379 49.0429 72.0946 49.0429C77.1193 49.0429 81.2845 45.3426 82.038 40.5269H95.159C96.0217 40.5269 96.719 39.828 96.719 38.9669V28.3215C96.719 28.0688 96.6582 27.8208 96.5412 27.5961Z"
      fill="#00AED9"
    />
  </svg>
));

export default CarIcon;
